import React from "react";

// region Languages
import useTranslation from "@languages/useTranslation";
import { AnnouncementMessages } from "@languages/interfaces";
// endregion Languages
// region Libraries
import { Notifications } from "@libraries/mui/icons";
// endregion Libraries
// region Styles
import * as Styled from "./styles";
// endregion Styles

// region Interfaces
interface NotificationBellProps {
  unreadCount: number;
  onClick: (event: React.MouseEvent<HTMLDivElement>) => void;
}
// endregion Interfaces

/**
 * Navbar bell with the unread-announcements badge (gold, hidden when zero,
 * capped at "9+"). The parent owns the dropdown anchor, like the language icon,
 * and holds a ref to the bell so the dropdown can also be opened from elsewhere.
 */
const NotificationBell = React.forwardRef<HTMLDivElement, NotificationBellProps>(({ unreadCount, onClick }, ref) => {

  const { t } = useTranslation();

  return (
    <Styled.Container
      ref={ref}
      onClick={onClick}
      title={t(AnnouncementMessages.bellTooltip)}
      aria-label={t(AnnouncementMessages.bellTooltip)}
      role="button"
    >
      <Notifications />
      {unreadCount > 0 && (
        <Styled.CountBadge aria-hidden>{unreadCount > 9 ? "9+" : unreadCount}</Styled.CountBadge>
      )}
    </Styled.Container>
  );
});

NotificationBell.displayName = "NotificationBell";

export default React.memo(NotificationBell);
